import React from 'react';
export function FooterSection() {
  return <footer className="bg-black text-gray-400 py-10 font-body text-sm" data-id="element-44">
      <div className="container mx-auto px-4 text-center" data-id="element-45">
        <div className="flex flex-wrap justify-center gap-6 mb-6" data-id="element-46">
          <a href="#" className="hover:text-white transition-colors" data-id="element-47">
            Inicio
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-48">
            Política de Reembolso
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-49">
            Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-50">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-51">
            Contacto
          </a>
        </div>
        <p className="mb-6" data-id="element-52">
          © {new Date().getFullYear()} Manual de Sanación Natural. Todos los
          derechos reservados.
        </p>

        <div className="border-t border-gray-700 pt-6 mt-6 max-w-3xl mx-auto" data-id="element-53">
          <p className="text-gray-500 text-xs leading-relaxed" data-id="element-54">
            <strong className="text-gray-400" data-id="element-55">Aviso legal:</strong> Este sitio
            web no forma parte de Facebook ni de Meta Platforms, Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
            FACEBOOK es una marca registrada de META PLATFORMS, Inc. Los
            resultados pueden variar de persona a persona. Este producto no
            pretende diagnosticar, tratar, curar ni prevenir ninguna enfermedad.
            La información proporcionada en este sitio web no sustituye el
            consejo médico profesional. Consultá siempre a un profesional de la
            salud antes de comenzar cualquier programa de bienestar o modificar
            tu dieta.
          </p>
        </div>
      </div>
    </footer>;
}